import commonConfig from '../../config/commonConfig';
const chnlConfig = {
  svcHost: commonConfig.svcHost,
  stubHost: process.env.PUBLIC_URL,

  gatewayLogon: {
    method: 'LOGON',
    url: '/logon',
    timeout: 60000,
  },
  saasTokenAuth: {
    method: 'SAAS',
    url: '/anonymousCommsToken',
    timeout: 60000,
  },
  gatewayLogoff: {
    method: 'GET',
    url: '/gateway/authcontroller/logoff.json',
    //url: '/gateway/authcontroller/logoff?idv_cmd=idv.Logoff&ts=' + new Date().getTime(),
    timeout: 60000,
  },
  keepAlive: {
    method: 'GET',
    url: '/gateway/authcontroller/keepAlive',
    timeout: 60000,
  },
};

export default chnlConfig;
